/**
 * The Flux→Zustand mirror debounces its (expensive) asset pass, so a
 * just-attached media object can still be pending in the debounce window while
 * the rest of `omni` is current. Non-React correctness boundaries that read
 * `omni.assets` — chiefly the channel-less save mapping — register the mirror's
 * `flush` here so they can settle that pass before reading, rather than mapping
 * stale assets (e.g. dropping a document attached moments before Save).
 *
 * Registration doubles as the "bridge is active" signal, mirroring
 * `omniWriteTarget`: with no bridge mounted there is nothing to flush and
 * callers no-op.
 */
let flushOmniMirror: (() => void) | null = null

export function registerOmniMirrorFlush(flush: () => void): () => void {
  flushOmniMirror = flush
  return (): void => {
    flushOmniMirror = null
  }
}

export function getOmniMirrorFlush(): (() => void) | null {
  return flushOmniMirror
}
